import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  getPageTutorialVideoUrl,
  getLoomEmbedUrl,
} from "../../config/pageTutorials";
import { selectUser } from "../../store/userSelectors";
import "./WatchPageTutorial.css";

const WatchPageTutorial = ({
  videoKey,
  buttonText = <>Watch Page Tutorial<i className="fa fa-play-circle ml-2" aria-hidden="true" /></>,
  className = "",
  buttonClassName = "btn linear-gradient yr-add-new",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const user = useSelector(selectUser);
  const isPlgAccount = user?.is_plg_account === true;

  const videoShareUrl = getPageTutorialVideoUrl(videoKey, user?.plg_account_type);
  const videoEmbedSrc = getLoomEmbedUrl(videoShareUrl, { autoplay: true });

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen]);

  if (!isPlgAccount || !videoEmbedSrc) return null;

  return (
    <div className={`watch-page-tutorial ${className}`.trim()}>
      <button
        type="button"
        className={buttonClassName}
        onClick={() => setIsOpen(true)}
      >
        <span>{buttonText}</span>
      </button>
      {isOpen && (
        <div
          className="watch-page-tutorial-modal"
          role="dialog"
          aria-modal="true"
          aria-label="Page tutorial video"
          onClick={() => setIsOpen(false)}
        >
          <div
            className="watch-page-tutorial-modal__content"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="watch-page-tutorial-modal__close"
              aria-label="Close tutorial video"
              onClick={() => setIsOpen(false)}
            >
              &times;
            </button>
            <div className="watch-page-tutorial-modal__embed">
              <iframe
                title="Page tutorial video"
                src={videoEmbedSrc}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WatchPageTutorial;
